import { createAppKit } from "@reown/appkit/vue";
import { type AppKitNetwork, mainnet } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

// 1. Get projectId from https://cloud.reown.com
const projectId = "28d5417051c04ced4fbae071f5b75797";
const metadata = {
  name: "THELOSTBEASTS",
  description: "THELOSTBEASTS",
  url: "https://lostbeasts.net",
  icons: ["https://lostbeasts.net/logo.png"],
};
// const projectId = "64cc7c6c222514cd65ffa4f1efa82f4e";

// // 2. Create a metadata object
// const metadata = {
//   name: "THELOSTBEASTS",
//   description: "THELOSTBEASTS",
//   url: "https://u78yuk8.top",
//   icons: ["https://u78yuk8.top/logo.png"],
// };
// /
// 3. Set the networks
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const networks: [AppKitNetwork, ...AppKitNetwork[]] = [mainnet];

// 4. Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
});

// 5. Create the modal
export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
  },
});
